// extracted by mini-css-extract-plugin
export default {"title":"QuoteModal_title__N9y7C","radio":"QuoteModal_radio__JDjZj","inputRow":"QuoteModal_inputRow__A0p1S","num":"QuoteModal_num__OFWYR","col":"QuoteModal_col__1kxn-"};